import { ServiceCategory } from "../types"

type Details = {
  [service in ServiceCategory]: {
    header: string
    bulletpoints: {
      title: string
      body: string
    }[]
  }
}

export const details: Details = {
  color: {
    header: 'Miből áll egy színtanácsadás?',
    bulletpoints: [
      {
        title: 'Ismerkedés, elmélet',
        body: 'Minden színtanácsadás egy kis beszélgetéssel kezdődik. Egy kávé vagy tea mellett egymásra hangolódunk, és közben elmesélem neked a színtípus elmélet alapjait. Ne aggódj, nem lesz unalmas! Ez a rész elengedhetetlen ahhoz, hogy a később önállóan is kamatoztatni tudd a színtanácsadáson szerzett tudásodat.',
      },
      {
        title: 'Kendőzés',
        body: 'Ezután következik az igazi látványosság: a színkendőzés! Lépésről lépésre végigvezetlek a színeken és együtt megkeressük a hozzád leginkább passzoló árnyalatokat.',
      },
      {
        title: 'Rúzspróba',
        body: 'A színkendőzés levezetése a rúzspróba, ahol a színtípusodhoz passzoló rúzsokkal is megerősítjük a színkendőzés eredményét, vagyis a színtípusodat és az altípusodat. Próbálhatsz hétköznapi nude-okat, rózsaszíneket, pirosakat, vagy akár egy-egy extrább árnyalatot is, mindent a színtípusodhoz passzoló színekben.',
      },
      {
        title: 'Utánkövetés',
        body: 'A személyes találkozó után sem engedem el a kezed, hiszen egy színkártya, egy digitális színtípus tudástár (altípusra lebontva), és egy opcionálisan igénybe vehető ingyenes 30 perces online konzultáció fog segíteni a színtanácsadás utáni életedben.',
      },
    ]
  },
  body: {
    header: 'Miból áll egy testalkat tanácsadás?',
    bulletpoints: [
      {
        title: 'Kérdőív és ismerkedés',
        body: 'A találkozásunk előtt küldeni fogok neked egy kérdőivet, aminek segítségével kicsit megismerhetem az öltözködési szokásaidat, preferenciáidat. Így a személyes találkozóra már én is úgy érkezem, hogy van némi elképzelésem rólad, illetve te is végiggondolhatod általa, hogy mire is vágysz. Egy kávé vagy tea mellett beszélgetünk kicsit minderről, aztán belecsapunk a közepébe!',
      },
      {
        title: 'Testi adottságaid felmérése, lehetőségeid meghatározása',
        body: 'Fontos tudnod, hogy nem foglak bekategorizálni. Az egyéni tulajdonságaidat, testarányaidat fogjuk figyelni, és ezekre fogunk fókuszálni. Centivel lemérem a méreteidet (pl. váll-derék-csípő szélesség, torzó-láb arány), megállapítjuk, milyen testrészeid hangsúlyozására vagy ellensúlyozásra érdemes odafigyelni annak függvényében, hogy te mit akarsz sugározni magadról. A kérdéses területek optikai formálásáról fogunk beszélni, melyeket sok-sok kép segítségével is alátámasztok.',
      },
      {
        title: 'Ruháid vagy pinterest táblád átnézése',
        body: 'Miután mindent megbeszéltünk, lehetőséged van megmutatni nekem néhány ruhádat (akár élőben, akár fotón), amiket kielemzünk: miért jók vagy kevésbé jók a testi adottságaidhoz. Emellett készíthetsz Pinterest táblát is olyan outfitekről, amelyek bejönnek neked. Közösen végignézzük, hogy stílus szempontjából miről árulkodik a gyűjtésed, megfogalmazzuk a vágyott irányt, és konkrét tippekkel segítelek a stílusod megfogalmazásában és elérésében. Közösen végignézzük, hogy stílus szempontjából miről árulkodik a gyűjtésed, megfogalmazzuk a vágyott irányt, és konkrét tippekkel segítelek a stílusod megfogalmazásában és elérésében.',
      },
      {
        title: 'Utánkövetés',
        body: 'A személyes találkozó után sem engedem el a kezed, hiszen egy írott összegzés a méreteidről, jellemzőidről, egy digitális, sok-sok képet tartalmazó öltözködési ajánló, és egy opcionálisan igénybe vehető ingyenes 30 perces online konzultáció fog segíteni a testalkat tanácsadás utáni életedben.',
      },
    ]
  },
  other: {
    header: 'other header',
    bulletpoints: []
  }
}
